import { LogLevel } from '@azure/msal-browser'

// Get the base URL
const getRedirectUri = () => {
  // For QA/Production
  if (window.location.hostname !== 'localhost') {
    return window.location.origin
  }
  // For local development with subdirectory
  return `${window.location.origin}`
}

// Post-logout landing page (dedicated route that performs final cleanup)
const getPostLogoutRedirectUri = () => `${getRedirectUri()}/logout`

// MSAL Configuration
export const msalConfig = {
  auth: {
    clientId: 'b4fa526a-780d-4aad-bec2-4fd10d176d83', // Application ID
    authority: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c', // Azure tenant ID
    
    redirectUri: getRedirectUri(),
    postLogoutRedirectUri: getPostLogoutRedirectUri(),
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage', // "sessionStorage" or "localStorage"
    storeAuthStateInCookie: false, // Set to true for IE 11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Info:
            console.info(message)
            return
          case LogLevel.Verbose:
            console.debug(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            return
          default:
            return
        }
      },
    },
  },
}

// Add scopes for the access token to be used at Microsoft identity platform endpoints
export const loginRequest = {
  scopes: ['User.Read'],
}

// Add the endpoints here for Microsoft Graph API services you'd like to use
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
}

// API Configuration
export const apiConfig = {
  scopes: ['User.Read'],
  uri: import.meta.env.VITE_API_BASE_URL || 'https://localhost:7202/api',
}
